import classNames from "classnames"
import { useStore } from "@features/common"
import { IconInstagram, IconMail, IconSubstack, IconTikTok } from "@lib/icons"
import { observer } from "mobx-react"

interface ContactsProps {
  classes?: {
    container?: string
    link?: string
  }
}
export const Contacts = observer(function Contacts(props: ContactsProps) {
  const { classes } = props
  const { GlobalModel } = useStore()

  const isRuVersion =
    GlobalModel.lang === "ru" || GlobalModel.countryCode === "ru"

  const links = isRuVersion
    ? [
        {
          id: "tiktok",
          href: GlobalModel.getTemplate("tiktok_link"),
          Icon: IconTikTok,
        },
        {
          id: "substack",
          href: GlobalModel.getTemplate("substack_link"),
          Icon: IconSubstack,
        },
        {
          id: "mail",
          href: GlobalModel.config.mailToLink,
          Icon: IconMail,
        },
      ]
    : [
        {
          id: "instagram",
          href: GlobalModel.getTemplate("instagram_link"),
          Icon: IconInstagram,
        },
        {
          id: "tiktok",
          href: GlobalModel.getTemplate("tiktok_link"),
          Icon: IconTikTok,
        },
        {
          id: "substack",
          href: GlobalModel.getTemplate("substack_link"),
          Icon: IconSubstack,
        },
        {
          id: "mail",
          href: GlobalModel.config.mailToLink,
          Icon: IconMail,
        },
      ]

  const defaultClasses = "flex space-x-4"

  return (
    <div className={classNames(defaultClasses, classes?.container)}>
      {links.map(({ href, Icon, id }) => (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className={classNames("transition-colors", classes?.link)}
          data-test-id={`contacts__${id}`}
          aria-label={id}
          key={id}
        >
          <Icon className="w-8 h-8" />
        </a>
      ))}
    </div>
  )
})
